import { useState } from 'react';
import Button from '@material-ui/core/Button';
import LockClockIcon from '@material-ui/icons/Timelapse';
import { PublicKey } from '@solana/web3.js';
import strings from '../../localization';
import { usePoolInfo } from '../../utils/tokenStaking/hooks';
import { Pool } from '../../utils/tokenStaking/program';
import TokenStakeDialog from './TokenStakeDialog';

export interface StakeTokenButtonProps {
  mint: PublicKey;
  symbol: string;
  /** Pass a known pool to skip the lookup (Marketplace batches it). */
  pool?: Pool | null;
  size?: 'small' | 'medium';
}

/** Renders only when a staking pool exists for the mint. */
export default function StakeTokenButton({ mint, symbol, pool, size }: StakeTokenButtonProps) {
  const [open, setOpen] = useState(false);
  const lookup = usePoolInfo(pool === undefined ? mint : null);
  const exists = pool === undefined ? !!lookup.data : !!pool;
  if (!exists) return null;
  return (
    <>
      <Button
        variant="outlined"
        color="primary"
        size={size}
        startIcon={<LockClockIcon />}
        onClick={() => setOpen(true)}
      >
        {strings.stake}
      </Button>
      <TokenStakeDialog open={open} onClose={() => setOpen(false)} mint={mint} symbol={symbol} />
    </>
  );
}
